import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/**
 * CRITICAL FIX: Monkey-patch removeChild and insertBefore to prevent
 * "Failed to execute 'removeChild' on 'Node'" crashes.
 *
 * Root cause: Browser extensions (Grammarly, translation, ad blockers, etc.)
 * and Chrome's built-in features can modify the DOM outside React's control.
 * When React tries to reconcile its virtual DOM with the actual DOM,
 * it finds nodes that have been moved/wrapped/removed by these external tools.
 *
 * This is a well-known React issue: https://github.com/facebook/react/issues/11538
 * This fix is used by major production React apps.
 */
if (typeof Node !== "undefined") {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      console.warn(
        "[DOM Safety] removeChild: node is not a child of this parent. Skipping to prevent crash."
      );
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn(
        "[DOM Safety] insertBefore: reference node is not a child of this parent. Skipping to prevent crash."
      );
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
